import Attachment from './Attachment'
import DfmFeedback from './DfmFeedback'
import ProcessesDetails from './ProcessesDetails'
import ModelConfiguration from './ModelConfiguration'
import ImModelConfiguration from './ImModelConfiguration'

export default {
    Attachment,
    DfmFeedbackDeprecated: DfmFeedback,
    ProcessesDetailsDeprecated: ProcessesDetails,
    ModelConfigurationDeprecated: ModelConfiguration,
    ImModelConfiguration,
}
